import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import { FC } from 'react';
import Skeleton from './skeleton';

const DynamicTopMsg = dynamic(() => import('./Content'), {
  ssr: false,
  loading: Skeleton
});

type IProps = Record<string, any>;

const TopMessageV3: FC<IProps> = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicTopMsg {...props} />;
};

export default TopMessageV3;
